import { createContext, useContext } from "react";
import { useEffect } from "react";

import { NotifyInput } from "./types";
import { NotificationType } from "./types";

export const NotificationContext = createContext<{
  notify: (notification: NotifyInput) => { dismiss: () => void };
}>({
  notify: () => ({ dismiss: () => void 0 }),
});

export function useNotify() {
  const { notify } = useContext(NotificationContext);
  return notify;
}

export const useNotifyError = ({
  isError,
  title,
  description,
  type = "error",
}: {
  isError: boolean;
  title: string;
  description?: string;
  type?: NotificationType;
}) => {
  const notify = useNotify();

  useEffect(() => {
    if (isError) {
      notify({
        title,
        description,
        type,
      });
    }
  }, [isError, title, description, type, notify]);
};
